<template>
  <v-container>
    <center>
      <div class="map-dropdown" style="margin-bottom: 8px;">
        <v-menu :close-on-content-click="false" v-model="showDropdown">
          <template v-slot:activator="{ on }" >
            <v-btn v-on="on" >
              <v-icon>mdi-menu-down</v-icon>Fill Available
              <v-img src="/img/icons/map-icons/red-circle.png"></v-img>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <span class="menu-items">Fill Available</span>
              <v-img src="/img/icons/map-icons/red-circle.png"></v-img>
              <v-switch v-model="haveFillEnabled"></v-switch>
            </v-list-item>
            <v-list-item>
              <span class="menu-items">Fill Needed</span>
              <v-img src="/img/icons/map-icons/blue-circle.png"></v-img>
              <v-switch v-model="needFillEnabled"></v-switch>
            </v-list-item>
            <v-list-item>
              <span class="menu-items">Topsoil Available</span>
              <v-img src="/img/icons/map-icons/green-circle.png"></v-img>
              <v-switch v-model="haveTopSoilEnabled"></v-switch>
            </v-list-item>
            <v-list-item>
              <span class="menu-items">Topsoil Needed</span>
              <v-img src="/img/icons/map-icons/purple-circle.png"></v-img>
              <v-switch v-model="needTopSoilEnabled"></v-switch>
            </v-list-item>
            <center>
              <v-btn color="primary" @click="showDropdown = false">Done</v-btn>
            </center>
          </v-list>
        </v-menu>
        <v-btn class="ml-4" @click="updateMyLocation">
          <v-icon>mdi-crosshairs-gps</v-icon>
        </v-btn>
      </div>

      <center>
        <GmapMap :center="center" :zoom="11" @center_changed="centerChanged" @bounds_changed="boundsChanged" @idle="mapIdle" style="width: 100%; height: 75vh" :options="{
            zoomControl: true,
            fullscreenControl: true,
            clickableIcons: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            disableDefaultUI: false
          }">
          <GmapMarker
            :key="m.id"
            v-for="m in computedLocations"
            :position="m.position"
            :clickable="true"
            :draggable="false"
            :icon="m.iconLoc"
            @click="toggleInfoWindow(m)"
          />
          <gmap-polygon :paths="shaded_paths" :options="{strokeWeight: 0, fillOpacity: 0.20}"></gmap-polygon>
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen=false"
          ></gmap-info-window>
        </GmapMap>
      </center>
      <div v-if="zoom_warning" class="zoom-warnign-message">
        Zoom in to see all markers
      </div>
      <div v-show="false" ref="pointRender">
        <h2>{{currentMarker.entry_type_name}}</h2>
        <h2 v-if="currentMarker.loads">{{currentMarker.loads}} loads</h2>
        <h2>{{currentMarker.soilType}}</h2>
        <h2 v-if="currentMarker.price">Price: ${{currentMarker.price}}</h2>
        <div v-if="loggedIn">
          <a :href="currentMarker.mapsQuery" target="_blank">
            <h2>{{currentMarker.address1}}</h2>
            <h2>{{currentMarker.city}}</h2>
          </a>
          <h2>{{currentMarker.name}}</h2>
          <a v-if="currentMarker.loads" :href="'tel:'+ currentMarker.phone" style="text-decoration: none;">
            <h2>
              <v-icon>mdi-phone-outline</v-icon>
              {{currentMarker.phone}}
            </h2>
          </a>
          <p class="comments">{{currentMarker.comments}}</p>
        </div>
        <a v-if="!loggedIn && currentMarker.loads" href="/signin">
          <h3>Sign In to view details</h3>
        </a>
      </div>
      <v-snackbar :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.message }}
        <v-btn text @click="snackbar.show = false">Close</v-btn>
      </v-snackbar>
    </center>
  </v-container>
</template>

<style scoped>
.menu-items {
  width: 80%;
}
.comments {
  font-size: larger;
  font-style: italic;
  white-space: pre-line;
  max-width: 175px;
  max-height: 75px;
}
.zoom-warnign-message {
  position: absolute;
  color: red;
  top: 60px;
  left: 60px;
  z-index: 99; 
}
</style>

<script>
import { firebase, db } from "@/firebaseInit.js";
import Geohash from 'latlon-geohash'
import { difference } from 'lodash';

const worldCoords = [
  {lat: 85, lng: 180 },
  {lat: 85, lng: 90 },
  {lat: 85, lng: 0 },
  {lat: 85, lng: -90 },
  {lat: 85, lng: -180 },
  {lat: 0, lng: -180 },
  {lat: -85, lng: -180 },
  {lat: -85, lng: -90 },
  {lat: -85, lng: 0 },
  {lat: -85, lng: 90 },
  {lat: -85, lng: 180 },
  {lat: 0, lng: 180 },
  {lat: 85, lng: 180 },
];

const showSearchArea = false;
const showZoomWarning = true;

export default {
  data: () => ({
    locations: [],
    infoWinOpen: false,
    showDropdown: false,
    infoWindowPos: null,
    currentMarker: {},
    needFillEnabled: false,
    haveFillEnabled: true,
    needTopSoilEnabled: false,
    haveTopSoilEnabled: false,
    loggedIn: false,
    infoOptions: {
      content: "",
      pixelOffset: {
        width: 0,
        height: -35
      }
    },
    center: { lat: 40.0379, lng: -76.3055 },
    reported_center: null,
    hashlist: [],
    shaded_paths: [],
    zoom_warning: false,
    user_location: null,
    snackbar: {
      show: false,
      message: null,
      color: "warning"
    }
  }),
  created() {
    this.checkUserStatus();
    this.updateMyLocation();
  },
  computed: {
    computedLocations() {
      let returnLocations = [];
      if (this.user_location) {
        let you_are_here = {
          id: "you_are_here",
          position: this.user_location,
          iconLoc: "/img/icons/map-icons/blue-dot.png",
          entry_type_name: "You are here",
        }
        returnLocations.push(you_are_here);
      }
      for (let entry of this.locations) {

        if (!this.needFillEnabled && entry.entry_type_id === "Need_Fill") continue;
        if (!this.haveFillEnabled && entry.entry_type_id === "Have_Fill") continue;
        if (!this.needTopSoilEnabled && entry.entry_type_id === "Need_Topsoil") continue;
        if (!this.haveTopSoilEnabled && entry.entry_type_id === "Have_Topsoil") continue;

        if (entry.coords) {
          let iconLocation = "/img/icons/map-icons/purple-circle.png";

          if (entry.entry_type_id == "Have_Fill") {
            iconLocation = "/img/icons/map-icons/red-circle.png";
          } else if (entry.entry_type_id == "Have_Topsoil") {
            iconLocation = "/img/icons/map-icons/green-circle.png";
          } else if (entry.entry_type_id == "Need_Fill") {
            iconLocation = "/img/icons/map-icons/blue-circle.png";
          }
          
          let mapsQuery = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(entry.street_address + "," + entry.city + "," + entry.state);
          if (!entry.city) {
            mapsQuery = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(entry.coords.latitude + ',' + entry.coords.longitude);
          }
          mapsQuery += '&t=m';

          var newLocations = {
            mapsQuery: mapsQuery,
            address1: entry.street_address,
            position: {
              lat: entry.coords.latitude,
              lng: entry.coords.longitude
            },
            iconLoc: iconLocation,
            city: entry.city,
            entry_type_name: entry.entry_type_name,
            name: entry.name,
            phone: entry.phone,
            price: entry.price,
            soilType: entry.soil_type_name,
            state: entry.state,
            emailAddress: entry.user_email,
            zip: entry.zip,
            comments: entry.comments,
            loads: entry.loads
          };
          returnLocations.push(newLocations);
        }
      }
      return returnLocations;
    }
  },
  watch: {
    $route(to){
      if (to.name == 'map') {
        this.checkUserStatus();
      }
    }
  },
  methods: {
    updateMyLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition( position => {
            this.user_location = { lat: position.coords.latitude, lng: position.coords.longitude };
            //hack: force a re-center by adding small random value to make it different than previously-bound value
            this.center = { lat: position.coords.latitude + (Math.random() / 100000), lng: position.coords.longitude };
            this.reported_center = this.center;
          }, () => {
            this.snackbar.show = true;
            this.snackbar.message = "Please allow location services";
            this.snackbar.color = "warning";
          }
        );
      } else {
        this.snackbar.show = true;
        this.snackbar.message = "Geolocation is not supported by this browser.";
        this.snackbar.color = "warning";
      }
    },
    async checkUserStatus() {
      let user = await firebase.getCurrentUser();
      this.loggedIn = !!user;
    },
    toggleInfoWindow: function(marker) {
      this.infoWindowPos = marker.position;
      this.infoWinOpen = true;
      this.currentMarker = marker;

      this.$nextTick(() => {
        this.infoOptions.content = this.$refs.pointRender.innerHTML;
      });
    },
    centerChanged: function(center) {
      this.reported_center = { lat: center.lat(), lng: center.lng() };
    },
    boundsChanged: function(bounds) {
      if (!bounds) return;
      this.reported_bounds = bounds;
    },    
    mapIdle: function() {
      this.getMapEntries(this.reported_center || this.center);
    },
    getMapEntries: function(center) {
      // determine the nine geohash boxes surrounding the center of the map
      // see https://www.movable-type.co.uk/scripts/geohash.html for background on geohashes
      // and for the library we use to do this
      const geohash = Geohash.encode(center.lat, center.lng, 4)
      const neighbors = Geohash.neighbours(geohash);
      const hashlist = [...Object.values(neighbors), geohash];
      
      const neighborNE = Geohash.bounds(neighbors.ne);
      const neighborSW = Geohash.bounds(neighbors.sw);
      this.zoom_warning = false;
      if (showZoomWarning && this.reported_bounds) {
        const boundsNE = this.reported_bounds.getNorthEast();
        const boundsSW = this.reported_bounds.getSouthWest();
        if (neighborNE.ne.lon < boundsNE.lng()
          || neighborNE.ne.lat < boundsNE.lat()
          || neighborSW.sw.lon > boundsSW.lng()
          || neighborSW.sw.lat > boundsSW.lat()
          ) {
          this.zoom_warning = true;
        }
      }

      if ( difference(hashlist, this.hashlist).length == 0) return;
      this.hashlist = hashlist;

      if (showSearchArea) {
        const neighborNW = Geohash.bounds(neighbors.nw);
        const neighborSE = Geohash.bounds(neighbors.se);
        const innerBox = []
        innerBox.push( {lat: neighborNW.ne.lat, lng: neighborNW.sw.lon})
        innerBox.push( {lat: neighborNE.ne.lat, lng: neighborNE.ne.lon})
        innerBox.push( {lat: neighborSE.sw.lat, lng: neighborSE.ne.lon})
        innerBox.push( {lat: neighborSW.sw.lat, lng: neighborSW.sw.lon})
        innerBox.push( {lat: neighborNW.ne.lat, lng: neighborNW.sw.lon})
        this.shaded_paths = [worldCoords, innerBox]
      }

      const filtered_entries = db.collection("entry").where("geohash4", "in", this.hashlist);
      this.$bind("locations", filtered_entries);
    }
  }
};
</script>